import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';
import { SiteDisplayItems } from 'requests/RequestSite';

export type SiteDisplayItemsExtend = SiteDisplayItems & {
	isSkip3_2: boolean;
	password_confirm: number;
	birthYear: number;
	birthMonth: number;
	birthDate: number;
};

export const initialSiteDisplayItemsExtendData: SiteDisplayItemsExtend = {
	id: undefined,
	search_site_cd: '',
	search_family_type: undefined,
	search_screen_id: '',
	gid: undefined,
	pass: undefined,
	mailaddress_1: undefined,
	mailaddress_2: undefined,
	mailaddress_3: undefined,
	mobile: undefined,
	lastname: undefined,
	firstname: undefined,
	kana_lastname: undefined,
	kana_firstname: undefined,
	birth: undefined,
	nickname: undefined,
	sex: undefined,
	country: undefined,
	zip: undefined,
	tel: undefined,
	pref_cd: undefined,
	address_2: undefined,
	address_3: undefined,
	address_4: undefined,
	address_5: undefined,
	address_6: undefined,
	family_cd: undefined,
	family_type: undefined,
	directmail_flg: undefined,
	payment_not_flg: undefined,
	withdrawal_flg: undefined,
	regist_ts: undefined,
	update_ts: undefined,
	tel_2: undefined,
	ext_1: undefined,
	ext_2: undefined,
	ext_3: undefined,
	data_util_agree_flg: undefined,
	isSkip3_2: false,
	password_confirm: undefined,
	birthYear: undefined,
	birthMonth: undefined,
	birthDate: undefined,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	siteDisplayItemsExtendData: SiteDisplayItemsExtend;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (
	dispatch: React.Dispatch<ActionBase>,
	siteDisplayItemsExtendData: SiteDisplayItemsExtend,
) => {
	const action = {
		action: SaveActionName,
		siteDisplayItemsExtendData: siteDisplayItemsExtendData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.siteDisplayItemsExtendData = thisAction.siteDisplayItemsExtendData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const SiteDisplayItemsExtendReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
